module.exports = __webpack_public_path__ + "static/img/fish.73743ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/icon/fish.png
// module id = UcCW
// module chunks = 2 3